// extracted by mini-css-extract-plugin
export var cell = "_4y-4";
export var headerCell = "_4y-2";
export var rowHeader = "_4y-3";
export var table = "_4y-1";
export var tableContainer = "_4y-0";